import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { Form, Button, Alert } from 'react-bootstrap';
import {
  required,
  youtubeUrl,
  number,
  minLength1,
  maxLength3,
  mustBeSelected,
  positiveNumber
} from '../../../../_utils/validators';
import { LESSON_TYPE_SLUG, moderatorMaxTagsAmount } from '../../../../config';
import { renderField } from '../../common/FormsControls.jsx';
import ContentRedactor from '../../common/FormFileds/Redactor/ContentRedactor.jsx';
import TagsField from '../../common/FormFileds/Tags/TagsField.jsx';
import DropzoneField from '../../common/FormFileds/Dropzone/DropzoneField.jsx';
import { Link } from 'react-router-dom';


const LessonsForm = (props) => {
  const { anyTouched, invalid, submitting, handleSubmit, submitSucceeded } = props;
  const difficultyOptions = props.difficulties.map(i => <option value={ i.value }>{ i.label }</option>);
  const listView = `/${props.lang}/my/moderator/${LESSON_TYPE_SLUG}/`;

  return <Form onSubmit={ handleSubmit } className={ '' + (anyTouched ? ' was-validate' : '') }>
    <Field component={ renderField }
           element="input"
           required='required'
           name='name'
           validate={ [required] }
           label={ gettext('Название') }
           placeholder={ gettext('Название') }/>

    <Field placeholder={ gettext('Краткое описание') }
           component={ renderField }
           element="auto_textarea"
           name='description'
           label={ gettext('Краткое описание') }
           helptext={ gettext('Краткое описание вашего урока. Будет выводиться вместе с миниатюрой в списке всех ' +
                              'раздела. Если оставить пустым, в качестве анонса будут использоваться первые ' +
                              'предложения основного текста.') }/>

    <Field component={ ContentRedactor }
           name='lesson_content'
           validate={ [required] }
           required='required'
           label={ gettext('Подробное описание') }
           placeholder={ gettext('Подробное описание') }/>

    <Field component={ TagsField }
           type={ LESSON_TYPE_SLUG }
           name='tags'
           required='required'
           validate={ [required, minLength1, maxLength3] }
           max_amount={ moderatorMaxTagsAmount }
           label={ gettext('Теги') }
           placeholder={ gettext('Добавить тег') }
           helptext={ gettext('Выберите 1 - 3 тега, максимально соответствующие уроку.') }/>

    <Field component={ renderField }
           element="input"
           required='required'
           name='video_url'
           validate={ [required, youtubeUrl] }
           label={ gettext('Ссылка на трейлер к уроку (Youtube)') }
           placeholder={ gettext('Ссылка на трейлер к уроку (Youtube)') }
           helptext={ gettext('Разрешается добавлять ссылки только на youtube') }/>

    <Field component={ renderField }
           element="input"
           required='required'
           name='lesson_video_content_url'
           validate={ [required, youtubeUrl] }
           label={ gettext('Ссылка на полное видео урока (Youtube)') }
           placeholder={ gettext('Ссылка на полное видео урока (Youtube)') }
           helptext={ gettext('Разрешается добавлять ссылки только на youtube') }/>

    <Field component={ renderField }
           element="input"
           name='price'
           label={ gettext('Цена') }
           placeholder={ 0 }
           validate={ [number, positiveNumber] }
           withInputGroup={ true }
           inputGroupPrepend={ props.currency }
           helptext={ gettext('Укажите стоимость, только цифры. Оставьте значение равное нулю для бесплатного распространения.') }/>

    <Field name="difficulty"
           required='required'
           component={ renderField }
           element="select"
           label={ gettext('Сложность') }
           validate={ [required, mustBeSelected] }>
      <option value={0}>{ gettext('---------') }</option>
      { difficultyOptions }
    </Field>

    <p><span className='font-weight-bold'>{ gettext('Загрузите PDF файлы (обязательно):') }</span><br/>
      <span className='text-muted small'>{ gettext('Минимум 1 файл в формате PDF.') + ' ' +
      gettext('Из первого добавленного PDF файла будет автоматически сформировано превью лекции.') }</span>
    </p>
    { props.hideDeleteFileActions &&
    <Alert variant='danger' className='mt-3'>{gettext('Внимание! Товар уже был продан.')}</Alert> }
    <Field component={ DropzoneField }
           name='files'
           existingFiles={ props.updatedFiles }
           hideDeleteActions={ props.hideDeleteFileActions }
           validate={[required]}
    />
      <fieldset className='mt-3'>
        <legend>{ gettext('Настройки:') }</legend>
          <Field component={ renderField }
                 element='checkbox'
                 name='checked'
                 componentLabel={ gettext('Модератором проверено') }/>
      </fieldset>
      <fieldset>
        <legend>SEO:</legend>
        <Field component={ renderField }
               element="input"
               required='required'
               name='seo_title'
               validate={ [required] }
               label={ gettext('Название (Title)') }/>
        <Field component={ renderField }
               element="input"
               required='required'
               name='seo_metadesc'
               validate={ [required] }
               label={ gettext('Описание (meta description)') }/>
        <Field component={ renderField }
               element="input"
               required='required'
               name='seo_metakeywords'
               validate={ [required] }
               label={ gettext('Ключевые слова, через запятую (meta keywords)') }/>
      </fieldset>

    { (submitting || invalid) &&
    <Alert variant='danger' className='mt-3'>{gettext('Проверьте правильность заполнения формы.')}</Alert> }

    <div className='text-lg-right mt-3'>
      <Link className='btn btn-outline-secondary mr-2 mt-2 mt-md-0' to={ listView } >
        <i className='icon icon-pencil'></i> { gettext('Отменить') }
      </Link>
      <Button variant="primary" type="submit" disabled={ submitting || invalid }
              className='mt-2 mt-md-0'>{ gettext('Сохранить') }</Button>
    </div>
  </Form>
}

let mapStateToProps = (state) => {
  return {
    lang: state.auth.lang,
    currency: state.auth.currency,

    initialValues: state.shop.initialValues,
    updatedFiles: state.shop.updatedFiles,
    hideDeleteFileActions: state.shop.hideDeleteFileActions,
    agreeForPromotion: state.auth.agree_for_promotion,
    difficulties: state.shop.difficulties,
  }
};


export default compose(
  connect(mapStateToProps, {}),
  reduxForm({ form: 'lessonsForm' })
)(LessonsForm);
